import React from "react";

const OCRFieldComponent = ({
  FieldComponent,
  ...other
}) => (
  <FieldComponent
    {...other}
  />
);

export default OCRFieldComponent;
